import {AppState} from '../reducer';

export const presUpdateSpinnerSelector = (state: AppState): boolean => state.spinnerReducer.presUpdateSpinner;
export const pageSpinnerSelector = (state: AppState): boolean => state.spinnerReducer.pageSpinner;
export const windowResizeSpinnerSelector = (state: AppState): boolean => state.spinnerReducer.windowResizeSpinner;
